html, body {
    margin:0;
}
#root, .appflow-container {
    height: 100vh;
}
